/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../state/store";
import { nodeClickDataActions } from "../../state/nodeClickDataState";
import { notificationDataStateActions } from "../../state/notificationDataState";
import { homeDataAction } from "../../state/homeState";
import { NodeActionActions } from "../../state/nodeActionState";
import { nodeSubtypeMappingActions } from "../../state/nodeSubtypeMappingState";
import { proximityConnectActions } from "../../state/proximityConnect";
import { errorDataActions } from "../../state/errorDataState";
import { stickyNotesActions } from "../../state/stickyNotesState";
import { keyboardEventDataActions } from "../../state/keyboardEventState";
import { customFieldsDataAction } from "../../state/customFields";
import { AddNodeDataProps } from "../add-node-options/addNodePopover";
import {
  NodeConfig,
  StickyNotesInterface,
} from "../../utilities/flowBuilder.utility";
import { useLocation, useParams } from "react-router-dom";
import { dasboardUrl } from "../../config";
import { getMacroChannelLabel } from "../../constants/MacroChannels";
import { cloneDeep } from "lodash";
import { getDateString } from "../../components/sticky-notes/utils";
import { macroNodeManager, MacroStatus } from "./macroNodeManager";
import { scaffoldDefaultMacroFlow } from "./helper/scaffoldDefaultMacroFlow";
import { validateMacroWithDFS } from "./helper/validateMacroWithDFS";
import { getLayoutedElements } from "./macroAutoLayout";
import { CampaignService } from "../../admin/services/CampaignService";
import { CrmService } from "../../admin/services/CrmService";
import { CustomFieldHelper } from "../../app/action-block/filter/helpers/customFieldHelper";
import { setViewPortToLocalStorage } from "../../utilities/localStorageUtility";
import useMultipleSelection from "../../utilities/copyPasteCustomHooks/useMultipleSelection";
import { FlowBuilderGlobalStyle } from "../flow-builder/style";
import CustomControls from "../flow-builder/customControls";
import ChatbotLoader from "../flow-builder/loader";
import CustomEdge from "../flow-builder/customEdge";
import MacroCustomNode from "./macroCustomNode";
import Modal from "../modal";
import SaveFlowModal from "../../app/entry-point/modals/saveFlowModal";
import ErrorsModal from "../../components/errorsModal";
import { ErrorStateHelper } from "../../services/helpers/errorStateHelper";
import {
  GetMacrosResponse,
  Macro,
  MacroNodeProps,
  GenericBackendConfig,
  ActionTypeBackend,
  FrontendNodeType,
  MacroNodeActionType,
  MacroNodeActionVerb,
} from "./macroNode.types";
import { useMacroSave } from "./helper/useMacroSave";
import { NodeSubType } from "../../models/nodeSubType";
import ReactFlow, {
  addEdge,
  Background,
  BackgroundVariant,
  MarkerType,
  ReactFlowInstance,
  useEdgesState,
  useOnViewportChange,
  useNodesState,
  useReactFlow,
  Viewport,
  MiniMap,
  XYPosition,
} from "reactflow";
import {
  COLORS,
  DeleteConfirmationModal,
} from "@bikdotai/bik-component-library";
import { canConnectEdge } from "../flow-builder/helper";
import { MacroStartingPointBackendConfig } from "../../app/action-block/macroStartingPoint/models";
import { ConnectToFlowBackendPayload } from "../../app/action-block/connectToFlow/types";
import { TicketActionsBackendPayload } from "../../app/action-block/ticketActions/types";
import { ResponseBlockBackendPayload } from "../../components/responseBlock/types";
import { NodeType } from "../../models/nodeType";

const initBgColor = COLORS.background.pureWhite;
const connectionLineStyle = {
  stroke: COLORS.background.brand,
  strokeWidth: "2",
  fill: "none",
};
const snapGrid: [number, number] = [25, 25];
const nodeTypes = {
  CustomNode: (props: any) => <MacroCustomNode {...props} />,
};
const edgeTypes = { CustomEdge };
const customStyle = {
  outline: "2px solid transparent",
  padding: 2,
  backgroundColor: COLORS.background.pureWhite,
  height: "auto",
  zIndex: 99,
};
const edgeOptions = {
  animated: false,
  style: {
    stroke: "#a1a1a5",
    strokeWidth: "2",
    fill: "none",
  },
  interactionWidth: 40,
  markerEnd: {
    type: MarkerType.ArrowClosed,
    strokeWidth: 5,
  },
};

const MacroNode = (props: MacroNodeProps) => {
  const {
    newNodeData,
    storeId,
    flowId,
    setIndex,
    index,
    stickyIndex,
    setStickyIndex,
  } = props;
  const { channel } = useParams();
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const { project } = useReactFlow();
  const nodeClickState = useAppSelector((state: any) => state.nodeClickState);
  const nodeActionState = useAppSelector((state: any) => state.nodeActionState);
  const homeState = useAppSelector((state: any) => state.homeState);
  const dispatcher = useDispatch();
  const nodeManager = macroNodeManager;
  const crmService = new CrmService();

  const [sourceNodeData, setSourceNodeData] = useState<{
    [key: string]: string | null;
  } | null>();
  const [targetNodeId, setTargetNodeId] = useState<string>("");
  const [addedNodeId, setAddedNodeId] = useState<string>("");
  const [clickedNodeId, setClickedNodeId] = useState<string>("");
  const [proximityHoverNodeId, setProximityHoverNodeId] = useState<string>("");
  const [proximityHoverNodeSubType, setProximityHoverNodeSubType] =
    useState<string>("");
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [showSaveModal, setShowSaveModal] = useState<boolean>(false);
  const [checkError, setCheckError] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [flowEditHistory, setFlowEditHistory] = useState<any>({});
  const [oldNodeCount, setOldNodeCount] = useState<number>(1);
  const [newNodeCount, setNewNodeCount] = useState<number>(1);
  const [reactFlowInstance, setReactFlowInstance] =
    useState<ReactFlowInstance>();
  const [pageLoaded, setPageLoaded] = useState<boolean>(false);
  const [builderDimension, setBuilderDimension] = useState<any>({});
  const stickyNotes = useAppSelector((state) => state.stickyNotesState.notes);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const errorStateComplete = useAppSelector((state) => state.errorDataState);
  const flowMeta = useAppSelector((state) => state.flowMetaState.flowMeta);
  const location = useLocation();
  const defaultViewport: Viewport = { x: 10, y: 15, zoom: 1 };
  const [mouseCursorPosition, setMouseCursorPosition] = useState<XYPosition>({
    x: 0,
    y: 0,
  });
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);
  const keyboardEventDataState = useAppSelector(
    (state) => state.keyboardEventState
  );

  const { selectedNodeIds } = useMultipleSelection(mouseCursorPosition);

  const { onFlowSaveConfirmed } = useMacroSave({
    storeId,
    flowId,
    index,
    stickyIndex,
    nodes,
    edges,
    setCheckError,
    setShowSaveModal,
    setSuccess,
  });

  const deleteStickyNote = (deletedNodeIds: string[]) => {
    try {
      const stickyNoteIds = deletedNodeIds.filter((id) => id.startsWith("S"));
      if (!stickyNoteIds.length) return;
      const notes = cloneDeep(stickyNotes);
      stickyNoteIds.forEach((id) => {
        delete notes[id];
      });
      dispatcher(
        stickyNotesActions.restoreNotes({
          notes: notes,
          id: "",
          data: {} as StickyNotesInterface,
        })
      );
    } catch (e) {
      console.error(e);
    }
  };

  const deleteNodes = (deletedNodeIds: string[]) => {
    if (!deletedNodeIds || !deletedNodeIds.length) return;

    deleteStickyNote(deletedNodeIds);

    const nodesTobeDeleted = nodes.filter((node: any) =>
      deletedNodeIds.includes(node.id)
    );
    if (!nodesTobeDeleted.length) return;

    const connectedEdges = edges.filter(
      (edge: any) =>
        deletedNodeIds.includes(edge.source) ||
        deletedNodeIds.includes(edge.target)
    );

    const { newNodes, error } = nodeManager.handleNodesDeletion(
      nodes,
      deletedNodeIds,
      connectedEdges
    );

    if (error) {
      showMessage(error, "");
      return;
    }

    if (connectedEdges.length) {
      const newEdges = edges.filter(
        (edge: any) => !connectedEdges.some((conn: any) => conn.id === edge.id)
      );
      setEdges([...newEdges]);
    }

    setNodes([...newNodes]);

    dispatcher(
      nodeClickDataActions.setEditNode({
        nodeType: "",
        nodeId: "",
        nodeSubType: "",
        data: {},
      })
    );
  };

  // --- Keyboard event handling ---
  useEffect(() => {
    if (keyboardEventDataState?.keyPressAction === "delete") {
      const isModalOpen =
        document.getElementById("cmpModal") ||
        document.getElementById("chatbot-builder-modal") ||
        document.getElementById("bik-modal");
      setIsDeleteConfirmationModalOpen(
        selectedNodeIds.length > 0 && !isModalOpen
      );
      dispatcher(keyboardEventDataActions.keyPressed({ keyPressAction: "" }));
    }
  }, [keyboardEventDataState?.keyPressAction]);

  // --- Screen dimension ---
  const getScreenHeight = () => {
    const builder = document.getElementsByClassName("react-flow__pane")?.[0];
    setBuilderDimension(builder?.getBoundingClientRect());
    return builder?.clientHeight;
  };

  const showMessage = (errorMessage: string, successMessage: string) => {
    dispatcher(
      notificationDataStateActions.setNotifications({
        errorMessage,
        successMessage,
      })
    );
  };

  const onLoad = (rf: ReactFlowInstance) => {
    setReactFlowInstance(rf);
  };

  useEffect(() => {
    if (reactFlowInstance && nodes.length > 0 && !pageLoaded) {
      reactFlowInstance.fitView({ padding: 0.2 });
      setPageLoaded(true);
    }
  }, [reactFlowInstance, nodes?.length]);

  // --- Viewport persistence ---
  useOnViewportChange({
    onStart: useCallback((viewport: Viewport) => {}, []),
    onChange: useCallback((viewport: Viewport) => {}, []),
    onEnd: useCallback((viewport: Viewport) => {
      if (storeId && flowId)
        setViewPortToLocalStorage(storeId, flowId, viewport);
    }, []),
  });

  // --- Node action handling (delete, edge ops, hover) ---
  useEffect(() => {
    const action = nodeActionState;
    if (action && Object.keys(action).length) {
      if (action.type === "node" && action.action === "delete") {
        deleteNodes([action.nodeId]);
      } else if (action.type === "edge" && action.action === "delete") {
        onEdgesDelete(action.edgeData);
      } else if (action.type === "edge" && action.action === "deleteMultiple") {
        onMultipleEdgeDelete(action.edgeData);
      } else if (
        action?.type === "edges" &&
        action?.action === "deleteAll" &&
        action?.edgeData?.length
      ) {
        const newEdges =
          edges.filter((edge: any) => !action.edgeData.includes(edge.target)) ||
          edges;
        setEdges([...newEdges]);
      } else if (action?.type === "edge" && action?.action === "hover") {
        const updatedEdges = edges.map((edge: any) => {
          if (action.edgeData?.id === edge.id) {
            edge.style = { ...edge.style, stroke: COLORS.background.brand };
          } else if (!action.edgeData) {
            edge.style = { ...edge.style, stroke: "#a1a1a5" };
          }
          return edge;
        });
        setEdges(updatedEdges);
      }
    }
  }, [nodeActionState]);

  const onMultipleEdgeDelete = (edgeData: any) => {
    const newEdges =
      edges.filter((edge: any) => {
        for (const data of edgeData) {
          let matches = false;
          if (data.deleteByHandle) {
            matches =
              edge.source === data.source &&
              edge.sourceHandle === data.sourceHandle;
          } else {
            matches =
              edge.target === data.target &&
              edge.source === data.source &&
              edge.sourceHandle === data.sourceHandle;
          }
          if (matches) return false;
        }
        return true;
      }) || edges;
    setEdges([...newEdges]);
  };

  useEffect(() => {
    setProximityHoverNodeId(nodeActionState?.nodeId);
    setProximityHoverNodeSubType(nodeActionState?.subType);
    setTargetNodeId(nodeActionState?.nodeId);
  }, [nodeActionState?.nodeId]);

  /**
   * Creates proper initial backend config based on node type/subType.
   * Ensures correct backend structure from the moment a node is created.
   *
   * @param nodeData - Node data containing type, subType, nodeId, nodeIndex, etc.
   * @returns Properly typed backend config for the node
   */
  const createInitialBackendConfig = (nodeData: any): any => {
    const { type, subType, automationChannel } = nodeData;

    // Map frontend subtypes to correct backend config structures
    switch (subType) {
      case NodeSubType.MACRO_STARTING_POINT: {
        // N1 node - typically created automatically, but handle explicitly for completeness
        const config: MacroStartingPointBackendConfig = {
          type: ActionTypeBackend.TRIGGER,
          subType: NodeSubType.MACRO_STARTING_POINT,
          channels: [automationChannel || "whatsapp"],
          reviewRequired: false,
          trigger: {
            conditions: [
              {
                operator_values: {},
              },
            ],
          },
        };
        return config;
      }

      case NodeSubType.CONNECT_TO_FLOW: {
        const config: ConnectToFlowBackendPayload = {
          type: ActionTypeBackend.START_A_FLOW,
          config: {
            flowId: "",
            flowName: "",
          },
        };
        return config;
      }

      case NodeSubType.MULTI_ACTION: {
        const config: TicketActionsBackendPayload = {
          type: ActionTypeBackend.MULTI_ACTION,
          actions: [],
          next: "",
        };
        return config;
      }

      case NodeSubType.TICKET_FORM: {
        const config = {
          type: ActionTypeBackend.MULTI_ACTION,
          subType: NodeSubType.TICKET_FORM,
          next: "",
        };
        return config;
      }

      case NodeSubType.RESPONSE_BLOCK: {
        const config: ResponseBlockBackendPayload = {
          channel: automationChannel || "whatsapp",
          type: ActionTypeBackend.MESSAGE,
          subType,
          message: {
            body: "",
            header: {
              mediaUrls: [],
              type: "text",
              body: "",
            },
          },
          next: "",
        };
        return config;
      }

      // Default case for other node types
      default: {
        const config: GenericBackendConfig = {
          type: type,
          subType: subType,
        };
        return config;
      }
    }
  };

  const deriveFrontendConfigFromBackend = (id: string, backendConfig: any) => {
    if (!backendConfig) return {};

    const getResponseBlockTitle = (channel: string) => {
      return getMacroChannelLabel(channel) + " response";
    };

    const getHandoverBlockTitle = (subType: string): string => {
      if (subType === NodeSubType.TICKET_FORM) return "Ticket Form";
      return subType || "";
    };

    let fallbackTitle =
      backendConfig.subType === NodeSubType.RESPONSE_BLOCK
        ? getResponseBlockTitle(backendConfig.channel || "whatsapp")
        : getHandoverBlockTitle(backendConfig.subType);

    const derived: any = {
      nodeId: id,
      type: backendConfig.type,
      subType: backendConfig.subType,
      automationChannel: backendConfig.channel || "whatsapp",
      title: backendConfig.name || fallbackTitle,
      name: backendConfig.name || fallbackTitle,
    };

    if (id === "N1") {
      derived.type = NodeType.TRIGGER;
      derived.subType = NodeSubType.MACRO_STARTING_POINT;
    }

    switch (backendConfig.type) {
      case "message": {
        derived.type = FrontendNodeType.MESSAGE;
        // Handover block subtypes (TICKET_FORM) share type "message"
        // but must keep their own subType — do not default them to RESPONSE_BLOCK.
        if (backendConfig.subType === NodeSubType.TICKET_FORM) {
          derived.subType = backendConfig.subType;
          break;
        }
        derived.subType = NodeSubType.RESPONSE_BLOCK;
        derived.description =
          backendConfig.message?.body?.replace(/<[^>]+>/g, "") || "";
        const headerUrls = backendConfig.message?.header?.mediaUrls || [];
        if (headerUrls.length > 0) {
          const typeMap: any = {
            image: "Image",
            video: "Video",
            doc: "Document",
            document: "Document",
          };
          derived.mediaUrl = headerUrls[0].path;
          derived.media = typeMap[headerUrls[0].type?.toLowerCase()] || "image";
          derived.attachments = headerUrls.map((url: any) => ({
            mediaUrl: url.path,
            mediaName: url.fileName,
            type: typeMap[url.type?.toLowerCase()] || "Document",
            mediaSize: url.size || "",
          }));
        } else if (backendConfig.attachments) {
          // fallback for legacy
          derived.attachments = backendConfig.attachments;
          if (backendConfig.attachments[0]) {
            derived.mediaUrl = backendConfig.attachments[0].mediaUrl;
            derived.media = backendConfig.attachments[0].type;
          }
        }
        break;
      }
      case "multiAction": {
        // Legacy TICKET_FORM nodes were incorrectly saved with type "multiAction".
        // Detect and re-derive them as MESSAGE type to route to MessageBlockNode.
        if (backendConfig.subType === NodeSubType.TICKET_FORM) {
          derived.type = FrontendNodeType.MESSAGE;
          derived.subType = NodeSubType.TICKET_FORM;
          derived.title = "Ticket Form";
          break;
        }
        derived.type = FrontendNodeType.ACTION;
        derived.subType = NodeSubType.MULTI_ACTION;
        derived.title = "Ticket actions";
        break;
      }
      case "startAflow": {
        derived.type = FrontendNodeType.ACTION;
        derived.subType = NodeSubType.CONNECT_TO_FLOW;
        derived.description = backendConfig.config?.flowName || "";
        derived.flowChannel = backendConfig.config?.flowChannel || "";
        derived.title = backendConfig.title || "Connect to Flow";
        break;
      }
    }

    return derived;
  };

  // --- Fetch macro flow ---
  const fetchFlow = useCallback(async () => {
    setShowLoader(true);

    try {
      const response = (await crmService.getMacros({
        storeId: storeId,
        macroId: flowId,
      })) as GetMacrosResponse;

      if (
        response?.status === 200 &&
        response?.data?.data?.macros?.length > 0
      ) {
        const macroData: Macro =
          response.data.data.macros.find((m: Macro) => m.macroId === flowId) ??
          response.data.data.macros[0];
        const backendNodes = macroData.config || {};
        const macroIndex = macroData.index || 1;

        // Ensure N1 always exists
        const defaultN1Config = {
          type: NodeType.TRIGGER,
          subType: NodeSubType.MACRO_STARTING_POINT,
          reviewRequired: false,
          channels: macroData.channels || ["whatsapp"],
        };
        const mergedNodes: { [key: string]: any } = {
          N1: { ...defaultN1Config, ...backendNodes["N1"] },
          ...backendNodes,
        };

        // --- Auto-scaffold default flow for newly created macros ---
        let macroIndexMut = macroIndex;
        const existingNodeKeys = Object.keys(mergedNodes).filter(
          (k) => k !== "N1"
        );
        if (
          macroData.status === MacroStatus.CREATED &&
          existingNodeKeys.length === 0
        ) {
          const channels: string[] = mergedNodes["N1"]?.channels ||
            macroData.channels || ["whatsapp"];
          const { scaffoldedNodes, newIndex } = scaffoldDefaultMacroFlow(
            mergedNodes["N1"],
            channels,
            macroIndex
          );
          Object.assign(mergedNodes, scaffoldedNodes);
          macroIndexMut = newIndex;
        }
        // Build React Flow nodes directly from nested schemas
        const defaultN1Position = {
          x: 300,
          y: (getScreenHeight()! - 180) / 2 || 250,
        };
        const rfNodes = Object.entries(mergedNodes).map(
          ([id, cfg]: [string, any]) => {
            const localFeCfg = cfg?.frontendConfig || {};
            const derivedFeCfg = deriveFrontendConfigFromBackend(id, cfg);
            return {
              id,
              type: "CustomNode",
              style: customStyle,
              position:
                localFeCfg?.position ??
                (id === "N1" ? defaultN1Position : { x: 0, y: 0 }),
              data: {
                nodeData: {
                  ...cfg,
                  ...derivedFeCfg,
                  ...(localFeCfg?.nodeData || {}),
                  type:
                    id === "N1"
                      ? NodeType.TRIGGER
                      : localFeCfg?.nodeData?.type || derivedFeCfg.type,
                  subType:
                    id === "N1"
                      ? NodeSubType.MACRO_STARTING_POINT
                      : localFeCfg?.nodeData?.subType || derivedFeCfg.subType,
                  name: localFeCfg?.nodeData?.name || derivedFeCfg.name || "",
                  title:
                    localFeCfg?.nodeData?.title || derivedFeCfg.title || "",
                  nodeId: localFeCfg?.nodeData?.nodeId || id,
                  backendConfig: cfg,
                },
              },
            };
          }
        );

        // Sticky notes are now natively inside macro payload!
        const _stickyNotes = macroData.stickyNotes || {};
        const { index: stickyNotesIndex, ...pureStickyNotes } = _stickyNotes;

        const stickyRfNodes = Object.keys(pureStickyNotes).map((id: string) => {
          const note = (_stickyNotes as any)[id];
          return {
            id,
            type: "CustomNode",
            style: customStyle,
            position: note.position ?? { x: 0, y: 0 },
            data: {
              nodeData: {
                nodeId: id,
                type: "Sticky notes",
                subType: NodeSubType.STICKY_NOTES,
              },
            },
          };
        });

        // We calculate edges dynamically based on backend paths
        const rfEdges = macroNodeManager.rebuildEdgesFromConfig(mergedNodes);

        // Auto-layout using ELK.js — start from the N1 default position
        const allNodes = [...rfNodes, ...stickyRfNodes];
        const { nodes: layoutedNodes, edges: layoutedEdges } =
          await getLayoutedElements(allNodes, rfEdges, {
            origin: defaultN1Position,
          });
        setNodes(layoutedNodes);
        setEdges(layoutedEdges);
        setIndex(macroIndexMut);
        const nodeCount = rfNodes.length || 1;
        setOldNodeCount(nodeCount);

        // Set sticky notes counter from saved payload parameter
        setStickyIndex(stickyNotesIndex || 0);

        dispatcher(
          stickyNotesActions.restoreNotes({
            notes: pureStickyNotes as { [key: string]: StickyNotesInterface },
            id: "",
            data: {} as StickyNotesInterface,
          })
        );
      }
    } catch (error: any) {
      // Handle error silently
    }

    // Custom fields
    const campaignService = new CampaignService();
    const customFieldHelper = new CustomFieldHelper();
    const customFieldsResponse =
      await campaignService.getCustomerCustomFields(storeId);
    const customerCustomFields =
      customFieldHelper.parseCustomFieldFromApiToQueryBuilder(
        customFieldsResponse
      );

    dispatcher(
      customFieldsDataAction.setCustomerCustomFields(customerCustomFields)
    );
    dispatcher(
      customFieldsDataAction.setCustomFieldApiResponse(customFieldsResponse)
    );

    setShowLoader(false);
  }, [storeId, flowId, homeState?.storeId]);

  useEffect(() => {
    if (location.pathname.includes("/edit") && storeId) {
      fetchFlow();
    }
  }, [location.pathname, storeId]);

  // --- Node click → update canvas ---
  useEffect(() => {
    const { nodeId, nodeSubType, data, backendConfig } = nodeClickState;
    setClickedNodeId(nodeId);
    if (nodeId && nodeSubType && data && Object.keys(data).length) {
      setTimeout(() => {
        // Update visual node on canvas from nodeClickState data
        setNodes((nds: any) =>
          nds.map((node: any) => {
            if (node.id === nodeId) {
              return {
                ...node,
                data: {
                  ...node.data,
                  nodeData: {
                    ...node.data.nodeData,
                    ...data,
                    backendConfig:
                      backendConfig || node.data.nodeData.backendConfig,
                  },
                },
              };
            }
            return node;
          })
        );
        setClickedNodeId("");
        dispatcher(
          nodeClickDataActions.setEditNode({
            nodeId: "",
            nodeType: "",
            nodeSubType: "",
            data: {},
          })
        );
      }, 0);
    }
  }, [nodeClickState, setNodes]);

  const validateBeforeSave = () => {
    const nodesClone = cloneDeep(nodes);
    const backendNodes: { [id: string]: any } = {};
    nodesClone.forEach((n: any) => {
      const backendNodeConfig = n.data?.nodeData?.backendConfig;
      if (backendNodeConfig) {
        const descriptionNodeConfig =
          backendNodeConfig.subType === NodeSubType.MULTI_ACTION ||
          backendNodeConfig.type === ActionTypeBackend.MULTI_ACTION
            ? { description: n.data?.nodeData?.description || [] }
            : backendNodeConfig.subType === NodeSubType.TICKET_FORM
              ? {
                  description: n.data?.nodeData?.description || [],
                  subType: NodeSubType.TICKET_FORM,
                }
              : {};

        backendNodes[n.id] = {
          ...backendNodeConfig,
          frontendConfig: {
            position: n.position,
            ...(Object.keys(descriptionNodeConfig).length > 0 && {
              nodeData: descriptionNodeConfig,
            }),
          },
        };
      }
    });

    const validationResult = validateMacroWithDFS(
      nodesClone.filter((n: any) => !n.id.startsWith("S")),
      edges,
      flowMeta as { [key: string]: any }
    );

    if (!validationResult.isValid) {
      const formattedErrorState = new ErrorStateHelper().formatErrors(
        { [flowId]: validationResult.validationErrorPayload },
        flowId
      );
      dispatcher(
        errorDataActions.updateErrorState({
          ...errorStateComplete,
          errorModalOpenStatus: true,
          errors: { ...formattedErrorState.errors },
          errorsCount: formattedErrorState.errorsCount,
          warningsCount: formattedErrorState.warningsCount,
        })
      );
      showMessage("Node updation failed! Highlighted nodes are defected.", "");
      return false;
    }

    // Reset purely formatting errors if any
    dispatcher(
      errorDataActions.updateErrorState({
        ...errorStateComplete,
        errorModalOpenStatus: false,
        errors: {},
        errorsCount: 0,
        warningsCount: 0,
      })
    );
    return true;
  };

  useEffect(() => {
    updateNodesBasedOnErrorState();
  }, [errorStateComplete.errors, nodes.length]);

  const updateNodesBasedOnErrorState = () => {
    if (errorStateComplete.errors && nodes.length) {
      let defectedNodesFromBE: { [key: string]: { [key: string]: boolean } } =
        {};

      if (errorStateComplete.errors && errorStateComplete.errors[flowId]) {
        Object.keys(errorStateComplete.errors[flowId]).map((key) => {
          const errorData: { [key: string]: boolean } = {
            errors: false,
            warnings: false,
          };
          if (
            errorStateComplete.errors[flowId][`${key}`] &&
            errorStateComplete.errors[flowId][`${key}`].errors?.length
          ) {
            errorData.errors = true;
          }
          if (
            errorStateComplete.errors[flowId][`${key}`] &&
            errorStateComplete.errors[flowId][`${key}`].warnings?.length
          ) {
            errorData.warnings = true;
          }
          defectedNodesFromBE[key] = errorData;
        });
      }

      setNodes((nds: any) =>
        nds.map((node: any) => {
          if (
            defectedNodesFromBE[node.id] &&
            defectedNodesFromBE[node.id]?.errors
          ) {
            node.style = {
              ...node.style,
              border: "none",
              outline: "2px solid #D53434",
              "border-radius": "8px",
            };
          } else if (
            defectedNodesFromBE[node.id] &&
            defectedNodesFromBE[node.id]?.warnings
          ) {
            node.style = {
              ...node.style,
              border: "none",
              outline: "2px solid #FEC02D",
              "border-radius": "8px",
            };
          } else {
            node.style = {
              ...node.style,
              "border-radius": "8px",
              border: "none",
              outline: "none",
            };
          }
          return node;
        })
      );
    }
  };

  // --- Save button trigger ---
  useEffect(() => {
    const saveFlowClicked = homeState?.saveFlow;
    const skipSaveModal = homeState?.skipStatModal;
    if (saveFlowClicked) {
      if (!validateBeforeSave()) {
        dispatcher(
          homeDataAction.addState({
            ...homeState,
            saveFlow: false,
          })
        );
        return;
      }

      const macroMeta = (flowMeta as { [key: string]: any })?.[flowId] || {};
      setFlowEditHistory({
        email: homeState?.userData?.email,
        lastUpdatedTime: macroMeta.updatedAt,
      });
      const macroNodeCount =
        nodes.filter((n: any) => !n.id.startsWith("S")).length || 1;
      setNewNodeCount(macroNodeCount);
      setShowSaveModal(true);
      dispatcher(
        homeDataAction.addState({
          ...homeState,
          saveFlow: false,
        })
      );
      if (skipSaveModal) {
        onFlowSaveConfirmed(false, "Save");
      }
    }
  }, [homeState?.saveFlow]);

  // --- Add new node ---
  const onAdd = (nodeData: AddNodeDataProps | NodeConfig) => {
    let x = builderDimension.width / 2 || 1440;
    let y = builderDimension.height / 2 || 800;
    const xy = project({ x, y });
    x = xy.x;
    y = xy.y;

    const data = nodeData as unknown as any;
    const id: string = data.nodeId;
    if (id) {
      // Create proper backend config using helper function
      const backendConfig = createInitialBackendConfig(data);
      // Store backend config in RF node data
      const newNode = {
        id,
        type: "CustomNode",
        data: {
          color: initBgColor,
          nodeData: {
            ...nodeData,
            backendConfig,
          },
        },
        style: customStyle,
        position: { x, y },
      };
      setNodes((nds: any) => nds.concat(newNode));
      setAddedNodeId(id);
      setTimeout(() => {
        setAddedNodeId("");
      }, 700);
      dispatcher(
        NodeActionActions.updateState({
          type: MacroNodeActionType.NODE,
          action: MacroNodeActionVerb.CREATED,
          nodeId: "",
        })
      );
    }
  };

  // --- Edge connections ---
  const handleEdgeConnections = (edge_data: any) => {
    try {
      // Read from React Flow nodes (single source of truth)
      const rfNode = nodes.find((n: any) => n.id === edge_data?.fromNodeId);
      const fromNode = rfNode?.data?.nodeData?.backendConfig;
      if (!fromNode) return "";

      const { editableNode, error } = nodeManager.handleEdgeConnections(
        fromNode,
        edge_data
      );

      // Update the RF node's backendConfig
      setNodes((nds: any) =>
        nds.map((node: any) => {
          if (node.id === edge_data?.fromNodeId) {
            return {
              ...node,
              data: {
                ...node.data,
                nodeData: {
                  ...node.data.nodeData,
                  backendConfig: editableNode,
                },
              },
            };
          }
          return node;
        })
      );
      return error;
    } catch (error: any) {
      return error?.message || "error";
    }
  };

  const onConnect = useCallback(
    (params: any) => {
      // Read from React Flow nodes (single source of truth)
      const rfNode = nodes.find((n: any) => n.id === params.source);
      const sourceNode = rfNode?.data?.nodeData?.backendConfig;

      if (!sourceNode) return;

      const edge_data = nodeManager.getEdgeConnections(params);
      const canConnect_ = canConnectEdge(edge_data, reactFlowInstance);

      if (canConnect_) {
        const err = handleEdgeConnections(edge_data);
        if (!err) {
          setEdges((eds: any) =>
            addEdge({ ...params, type: "CustomEdge" }, eds)
          );
        }
      }
      updateProximityConnect(null);
      setProximityHoverNodeId("");
      setProximityHoverNodeSubType("");
      setTargetNodeId("");
    },
    [setEdges, nodes]
  );

  const onEdgesDelete = async (edgeData: any) => {
    if (Object.keys(edgeData)?.length) {
      // Update the React Flow nodes to remove the reference in backendConfig
      const { newNodes, newEdges, error } = nodeManager.handleEdgesDeletion(
        edges,
        edgeData,
        nodes
      );

      if (!error) {
        setNodes(newNodes);
        setEdges(newEdges);
      }
    }
  };

  // --- Proximity connect ---
  const proximityConnect = () => {
    if (sourceNodeData && Object.keys(sourceNodeData).length && targetNodeId) {
      const config = {
        ...edgeOptions,
        source: sourceNodeData.nodeId,
        sourceHandle: sourceNodeData.handleId,
        target: targetNodeId,
        targetHandle: "target",
      };
      onConnect(config);
      return;
    }
    updateProximityConnect(null);
    setProximityHoverNodeId("");
    setProximityHoverNodeSubType("");
  };

  const updateProximityConnect = (state: any) => {
    setSourceNodeData(state);
    dispatcher(
      proximityConnectActions.setState({
        listenToHover: state && !!Object.keys(state).length ? true : false,
      })
    );
  };

  // --- New node data from parent ---
  useEffect(() => {
    if (
      newNodeData &&
      newNodeData.id &&
      newNodeData.title &&
      newNodeData.subType
    ) {
      const nodeData: any = {
        nodeId: newNodeData.id as string,
        type: newNodeData.type as string,
        subType: newNodeData.subType as string,
        name: newNodeData.title as string,
        title: newNodeData.title as string,
        nodeIndex: newNodeData.nodeIndex as number,
        automationChannel: newNodeData.automationChannel || "",
      };

      if (nodeData.type === "Sticky notes") {
        // Create sticky note
        const stickyNote: StickyNotesInterface = {
          nodeId: nodeData.nodeId,
          content: "",
          createdDate: getDateString(
            new Date(
              new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
            )
          ),
          updatedDate: getDateString(
            new Date(
              new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
            )
          ),
        };
        dispatcher(
          stickyNotesActions.updateInsertNode({
            notes: {},
            id: nodeData.nodeId,
            data: stickyNote,
          })
        );
      }

      dispatcher(
        nodeSubtypeMappingActions.updateState({
          data: {},
          type: nodeData.subType,
          count: nodeData.nodeIndex,
        })
      );

      onAdd(nodeData);
    }
  }, [newNodeData.type, newNodeData.subType]);

  // --- Generate headers for save modal ---
  const generateHeader = () => {
    if (success) {
      return "Macro saved successfully";
    }
    return "Saving...";
  };

  const generateSubheader = () => {
    if (success) {
      return "It is available to all selected agents.";
    }
    return "Please wait...";
  };

  return (
    <FlowBuilderGlobalStyle
      channel={channel}
      addedNodeId={addedNodeId}
      proximityHoverNodeId={proximityHoverNodeId}
      clickNodeId={clickedNodeId}
      subType={proximityHoverNodeSubType}
    >
      {showLoader && <ChatbotLoader />}
      <ReactFlow
        className="validationflow"
        onInit={onLoad}
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onNodesDelete={(deletedNodes) =>
          deleteNodes(deletedNodes.map((n) => n.id))
        }
        onConnect={onConnect}
        onEdgeUpdate={undefined}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        defaultEdgeOptions={edgeOptions}
        connectionLineStyle={connectionLineStyle}
        snapToGrid={true}
        snapGrid={snapGrid}
        defaultViewport={defaultViewport}
        minZoom={0.2}
        attributionPosition="bottom-left"
        deleteKeyCode={null}
        onConnectStart={(_: any, params: any) => {
          updateProximityConnect(params);
        }}
        onConnectEnd={(e: any) =>
          setTimeout(() => {
            proximityConnect();
          }, 0)
        }
        connectOnClick={true}
        panOnDrag={true}
        panOnScroll={true}
        selectionOnDrag={true}
        nodesConnectable={true}
        onPaneMouseMove={(event) => {
          const x = event.clientX;
          const y = event.clientY;
          setMouseCursorPosition(project({ x, y }));
        }}
      >
        <Background
          variant={BackgroundVariant.Dots}
          size={0}
          style={{ backgroundColor: "F5F5F5" }}
        />
        <CustomControls storeId={storeId} flowId={flowId} isMacro={true} />
        <MiniMap
          zoomable
          nodeColor={COLORS.background.brandLight}
          maskColor={"rgba(0,0,0,0.3)"}
          pannable={true}
          ariaLabel={"Mini map"}
        />
      </ReactFlow>
      {showSaveModal && (
        <Modal>
          <SaveFlowModal
            saveType={"Save"}
            flowEditHistory={flowEditHistory}
            oldNodeCount={oldNodeCount}
            newNodeCount={newNodeCount}
            onClickCancel={() => {
              setShowSaveModal(false);
              setCheckError(false);
              setSuccess(false);
              dispatcher(
                homeDataAction.addState({
                  ...homeState,
                  fromTestModeToggle: false,
                })
              );
            }}
            buttonLoader={buttonLoader}
            onClickSave={async () => {
              setButtonLoader(true);
              await onFlowSaveConfirmed(false, "Save");
              setButtonLoader(false);
            }}
            checkError={checkError}
            showSuccess={success}
            error={""}
            heading={generateHeader()}
            subheading={generateSubheader()}
            onActivate={() => {}}
            showButtons={!homeState?.skipStatModal}
            isMacro={true}
            onExitMacro={() => {
              // If in iframe, navigate parent; otherwise navigate current window
              if (window.self !== window.top) {
                window.top!.location.href = `${dasboardUrl}/inbox/settings?selectedSettings=QUICK_REPLIES`;
              } else {
                window.location.href = `${dasboardUrl}/journeys/home`;
              }
            }}
          />
        </Modal>
      )}
      {errorStateComplete.errorModalOpenStatus && (
        <ErrorsModal
          onSave={() => onFlowSaveConfirmed(false, "Save")}
          onPublish={() => onFlowSaveConfirmed(false, "Save")}
        />
      )}
      {isDeleteConfirmationModalOpen && (
        <DeleteConfirmationModal
          confirmationText="Delete"
          header="Delete these nodes?"
          onCancelClicked={() => {
            setIsDeleteConfirmationModalOpen(false);
          }}
          onDeleteConfirmed={() => {
            setIsDeleteConfirmationModalOpen(false);
            deleteNodes(selectedNodeIds);
          }}
          subHeader="This action cannot be undone."
        />
      )}
    </FlowBuilderGlobalStyle>
  );
};

export default MacroNode;
